/*
 * View for the content page
 */

define(["marionette", "modules/contentsSplit/content/template/contentTemplate.html"], function (
  Marionette,
  ContentTemplate,
) {
  var ContentView = {};

  ContentView.contentLayout = Marionette.Layout.extend({
    template: ContentTemplate,
    regions: {
      contentTitle: "#contentTitle",
      contentLanguage: "#contentLanguage",
      contentUrls: "#contentUrls",
      contentPreview: "#contentPreview",
      contentModification: "#contentSelectors",
      contentTopics: "#contentTopics",
      contentNotes: "#contentNotes",
    },
    triggers: {
      "click #deleteContent": "delete:content",
      "click #history": "content:history",
    },
  });

  return ContentView;
});
